
<template>
    <div :style="mainContentViewHeight" class="main_center">
        <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
        <div class="search-drawer">
          <el-form :model="moreSearchForm" label-position="top" ref="form">
            <el-form-item label="数据所属部门：">
            <select-depart-tree 
                ref="selectDepartTreeRef"
                :type="'2'"
                :modelValue.sync="moreSearchForm.superviseDeptCodeList"  
                :isMultiple="true" 
                @handleDeptType="(val)=>changeDept(val,'5')" >
                </select-depart-tree>
             </el-form-item>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
            <el-button @click="refresh" plain size="small">重置</el-button>
          </div>
        </div>
      </searchBox>
        <div class="table_header">
            <div class="list_top">
            <div class="pageTitle">督查督办</div>
            <div class="search">
                <el-input class="my_input" placeholder="请输入督办对象、督办标题等关键字" v-model="keyword" @keyup.enter.native="searchHandler" clearable></el-input>
                <el-button type="primary"  @click="searchHandler" class="height_four">搜索</el-button>
                <el-button
                @click="moreSearchItem = true"
                icon="el-icon-arrow-down"
                size="mini"
                type="text"
                class="height_four"
            >更多搜索</el-button>
            </div>
            </div>
            <el-tabs v-model="activeName" @tab-click="tabClickHandler">
                <el-tab-pane label="本部门发出" name="sent">
                    <div slot="label">
                        <el-badge :value="sentDataNumber">
                            <span>本部门发出</span>
                        </el-badge>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="本部门收到" name="received">
                    <div slot="label">
                        <el-badge :value="recevedDataNumber">
                            <span>本部门收到</span>
                        </el-badge>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
       <div class="tableContent_">
        <template v-if="activeName==='sent'">
            <sendList :keyword="keywords" :tradeId="tradeId" @findDataNumber="getSentDataNumber" ref="sendList"></sendList>
        </template>
        <template v-if="activeName==='received'" >
            <replyList :keyword="keywords" :tradeId="tradeId" @findDataNumber="getRecevedDataNumber" ref="replyList"></replyList>
        </template>
       </div>
    </div>
</template>

<script>
import sendList from './sendList';
import replyList from "./replyList";
import { mapState } from "vuex";

import selectDepartTree from "@/views/modules/components/selectDepartTree"
export default {
    props: ['mainContentViewHeight'],
    components: {
        sendList,
        replyList,
        selectDepartTree
    },
    data() {
        return {
            activeName: 'sent',
            tradeId:'',
            moreSearchForm:{
                superviseDeptCodeList:[]
            },
            keyword: '',
            keywords: '',
            sentDataNumber: '',
            recevedDataNumber: '',
            moreSearchItem: false,

        };
    },
    created(){
        this.getTabCounts();
        if (this.$route.query.active === 'received') {
            this.activeName = 'received';
        } else {
            this.activeName = 'sent';
        }//获取监管中心下拉选项
    },
    watch:{
        moreSearchForm:{
            deep:true,
            immediate:true,
            handler(val){
              if(val.superviseDeptCodeList){
                sessionStorage.setItem("superviseAndHandleCodeList",JSON.stringify(val.superviseDeptCodeList))
              }
            }
        },
        uerdefultOptionCode:{
            handler (val,oldVal){
            if(val.length!==0){ 
                if(this.activeName==='sent'){
                this.$refs.sendList.getSendList({searchKey:this.keywords,superviseDeptCodeList: val,})
                }else{
                this.$refs.replyList.getReplyList({searchKey:this.keywords,superviseDeptCodeList: val,})
                }
                this.getTabCounts();
            }
            }
    }
    },
    computed:{
		...mapState({
            isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"},
            uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
        }),
	},
    methods: {
        changeDept(val,str){//切换部门
            this.moreSearchForm.superviseDeptCodeList=[]
            if(str==='5'){
            // 多选
                val.forEach((item,index)=>{
                if( item.type!=="region"){
                    this.moreSearchForm.superviseDeptCodeList.push(item.code)
                }
            })
            }
        },
        searchBtn(){
            if(this.activeName==='sent'){
               this.$refs.sendList.getSendList({searchKey:this.keywords,superviseDeptCodeList: this.moreSearchForm.superviseDeptCodeList||this.uerdefultOptionCode,})
            }else{
               this.$refs.replyList.getReplyList({searchKey:this.keywords,superviseDeptCodeList: this.moreSearchForm.superviseDeptCodeList||this.uerdefultOptionCode,})
            }
        },
        refresh(){
            this.moreSearchForm.superviseDeptCodeList=[]
           // 重置默认所属数据
           if( this.$refs.selectDepartTreeRef){
            this.$refs.selectDepartTreeRef.getUserTreeOption()
            }
         this.searchBtn();
        },
        dialogCancle() {
        this.moreSearchItem = false;
        },
        tabClickHandler(tab, event) {
            this.keywords = this.keyword;
            this.searchBtn();
        },

        searchHandler () {
            this.keywords = this.keyword;
            this.searchBtn();
        },

        getSentDataNumber (num) {
            // this.sentDataNumber = num;
        },

        getRecevedDataNumber (num) {
            // this.recevedDataNumber = num;
        },

        getTabCounts () {//获取基本信息
            this.$httpReq.post(`/application/inspector/getTabCount`,{superviseDeptCodeList:this.moreSearchForm.superviseDeptCodeList.length==0?this.uerdefultOptionCode:this.moreSearchForm.superviseDeptCodeList}).then(({data}) => {
                this.sentDataNumber = data.data? data.data[0].count:null;
                this.recevedDataNumber = data.data[1].count;
            })
        },


    },
};
</script>
<style lang="scss">
.table_header{
    .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
}
</style>
<style lang="scss" scoped>
    $main-color:#1890FF;
    .height_four{
        height: 40px;
    }
     
    .table_header{
        background: #ffffff;
        padding: 0px 24px;
        // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
        padding-top:24px;
        .list_top{
            display: flex;
            align-items: center;
        }
        .pageTitle{
            font-size: 18px;
            font-weight: 600;
            color: #000000; 
            height: 40px; 
         }
        .search{
            width:calc(100% - 80px);
            height:40px;
            float: right;
            display: flex;
            justify-content: center;
            align-items: center;
            >.my_input{
                width: 500px;
            }
            >.el-button--primary{
                background-color: $main-color;
                border-color: $main-color;
            }
        }
    }
    .table-body{
        // margin:16px 24px;
        background: #ffffff;
        // padding: 15px 24px;
        margin-bottom: 0;
        .opt-btn{
            margin-bottom:16px;
        }
    }
    /deep/ .el-badge__content.is-fixed {
        position: absolute;
        top: 10px ;
        right: 0px;
    }
</style>
